import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LitterService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  
  getLitterList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/LitterType/LitterTypeList`).pipe(
      catchError(this.error)
    );;
  }
  // Handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
